<ng-container [ngSwitch]="workOrderState">
  <ng-template #tocWorkerContextSection>
    <div
      class="toc-worker-context"
      *ngIf="shouldShowTocWorkerContext()">
      <div class="heading toc-worker-context__heading">
        <b>{{ workOrder.ownerWorkerUser.firstName }} {{ workOrder.ownerWorkerUser.lastName }}</b> competencies
      </div>

      <div *ngIf="tocWorkerContextLoading" class="toc-worker-context__message">
        Loading competency details...
      </div>

      <div *ngIf="tocWorkerContextError" class="toc-worker-context__message toc-worker-context__message--error">
        {{ tocWorkerContextError }}
      </div>

      <ng-container *ngIf="!tocWorkerContextLoading && !tocWorkerContextError">
        <div class="toc-summary-panel">
          <div class="toc-summary-panel__title">Competency Restrictions</div>
          <div class="toc-summary-panel__text">
            {{ tocAuthorisationSummary || 'No competency restrictions available.' }}
          </div>
        </div>

        <toc-competency-row
          *ngIf="tocWorkerCompetencies.length; else noTocCompetencies"
          [competencies]="tocWorkerCompetencies"
          cardType="user-readonly">
        </toc-competency-row>

        <ng-template #noTocCompetencies>
          <div class="toc-worker-context__message">No competencies found for this worker.</div>
        </ng-template>

      </ng-container>
    </div>
  </ng-template>

  <ng-template #openSessionsSummary>
    <div class="heading" *ngIf="!openSessions">
      There are currently workers checked on to this work order
    </div>
    <div class="heading" *ngIf="openSessions">
      <b>{{ openSessions.workers[0].name }}</b>
      <ng-container *ngIf="openSessions.workers[0].companyName">
        from <b>{{ openSessions.workers[0].companyName }}</b>
      </ng-container>
      is checked on to this work order
      <ng-container *ngIf="openSessions.workers.length > 1">
        with
        <ng-container *ngFor="let worker of openSessions.workers; let i = index">
          <ng-container *ngIf="i > 0">
            <b>{{ worker.name }}</b>
            <span *ngIf="i === openSessions.workers.length - 2"> and </span>
            <span *ngIf="i < openSessions.workers.length - 2">, </span>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="openSessions.guestCount > 0">
        <span *ngIf="openSessions.workers.length > 1">and</span>
        <span *ngIf="openSessions.workers.length === 1">with</span>
        {{ openSessions.guestCount }} {{ openSessions.guestCount > 1 ? 'guests' : 'guest' }}
      </ng-container>
    </div>
  </ng-template>

  <div class="action-bar" *ngSwitchCase="WorkOrderStateType.Pending">
    <div class="action-bar-header">
      <div class="message-group">
        <step-progress-bar class="approval-progress-tracker" [activeStep]=1 [scheduledStartTime]="workOrder.scheduledStartTime"></step-progress-bar>
      </div>
    </div>
    <div class="action-bar-footer">
      <div class="heading">This work order is pending approval</div>
      <div class="button-group" *ngIf="!isControlAdmin">
        <button class="btn btn-success" (click)="approveWorkOrder()"><span><i class="fas fa-check"></i></span> Approve</button>
        <button class="btn btn-danger" (click)="rejectWorkOrder()"><span><i class="fas fa-times"></i></span> Reject</button>
      </div>
    </div>
  </div>


  <div class="action-bar" *ngSwitchCase="WorkOrderStateType.Approved">
    <div class="action-bar-header">
      <div class="message-group">
        <step-progress-bar class="approval-progress-tracker" [activeStep]=2 [scheduledStartTime]="workOrder.scheduledStartTime"></step-progress-bar>
      </div>
    </div>
    <div class="action-bar-footer">
      <div class="heading">This work order has been approved and is pending release</div>
      <div class="button-group" *ngIf="!isControlAdmin">
        <button class="btn btn-success" (click)="releaseWorkOrder()"><span><i class="fas fa-paper-plane"></i></span> Release</button>
      </div>
    </div>
  </div>

  <div class="action-bar" *ngSwitchCase="WorkOrderStateType.Scheduled">
    <div class="action-bar-header">
      <div class="message-group">
        <step-progress-bar class="approval-progress-tracker" [activeStep]=4 [scheduledStartTime]="workOrder.scheduledStartTime"></step-progress-bar>
      </div>
    </div>
    <div class="action-bar-footer">
      <div class="heading">This work order has been scheduled for release on: <b>{{workOrder.scheduledStartTime | date: 'dd/MM/yy HH:mm'}}</b></div>
      <div class="button-group">
        <button class="btn btn-success" (click)="editSchedule()"><span><i class="fas fa-calendar-alt"></i></span> Reschedule</button>
      </div>
    </div>
  </div>

  <div class="action-bar" *ngSwitchCase="WorkOrderStateType.Overdue">
    <div class="action-bar-header">
      <div class="message-group">
        <step-progress-bar class="approval-progress-tracker" [activeStep]=3 [scheduledStartTime]="workOrder.scheduledStartTime"></step-progress-bar>
      </div>
    </div>
    <div class="action-bar-footer">
      <div class="heading">This work order needs to be rescheduled</div>
      <div class="button-group">
        <button class="btn btn-success" (click)="editSchedule()"><span><i class="fas fa-calendar-alt"></i></span> Reschedule</button>
      </div>
    </div>
  </div>

  <div class="action-bar" *ngSwitchCase="WorkOrderStateType.Available">
    <div class="action-bar-header">
      <div class="message-group">
        <step-progress-bar class="approval-progress-tracker" [activeStep]=3></step-progress-bar>
      </div>
    </div>
    <div class="action-bar-footer">
      <div *ngIf="!requiresToc" class="heading">This work order is available for check on</div>
      <div *ngIf="requiresToc" class="heading">This work order is available and awaiting transfer of control</div>
      <div class="button-group" *ngIf="!requiresToc || allowWorkOrderScheduling || !isControlAdmin">
        <button class="btn btn-success" *ngIf="!requiresToc" (click)="goToCheckInPage()"><span><i class="fas fa-sign-in-alt"></i></span> Check In</button>
        <button class="btn btn-secondary" *ngIf="allowWorkOrderScheduling" (click)="editSchedule()"><span><i class="fas fa-calendar-plus"></i></span> Add a schedule</button>
        <button class="btn btn-danger" *ngIf="!isControlAdmin" (click)="onCloseWorkOrder()"><span><i class="fas fa-times-circle"></i></span> Close</button>
      </div>
    </div>
  </div>


  <div class="action-bar" *ngSwitchCase="WorkOrderStateType.PendingXfer">
    <div class="action-bar-header">
      <div class="message-group">
        <step-progress-bar class="approval-progress-tracker" [transferOfControl]="true" [activeStep]=1 [workOrderState]="workOrderState"></step-progress-bar>
      </div>
    </div>
    <div class="action-bar-footer">
      <div class="heading">
        Transfer of control has been requested by <b>{{ workOrder.ownerWorkerUser.firstName }} {{ workOrder.ownerWorkerUser.lastName }}</b>
        <ng-container *ngIf="ownerWorkerCompanyName">
          from <b>{{ ownerWorkerCompanyName }}</b>
        </ng-container>
        <br>Please acknowledge or reject transfer of control request.
      </div>
      <div *ngIf="showTocButtons()" class="button-group">
        <button class="btn btn-success" (click)="acknowledgeWorkOrderTransfer(workOrder, true)"><span><i class="fas fa-check-circle"></i></span> Acknowledge</button>
        <button class="btn btn-danger" (click)="rejectWorkOrderTransfer(workOrder, true)"><span><i class="fas fa-times-circle"></i></span> Reject</button>
      </div>
      <ng-container *ngTemplateOutlet="tocWorkerContextSection"></ng-container>
    </div>
  </div>
  <div class="action-bar" *ngSwitchCase="WorkOrderStateType.XferAcknowledged">
    <div class="action-bar-header">
      <div class="message-group">
        <step-progress-bar class="approval-progress-tracker" [transferOfControl]="true" [activeStep]=1 [workOrderState]="workOrderState"></step-progress-bar>
      </div>
    </div>
    <div class="action-bar-footer">
      <div class="heading">
        Transfer of control to <b>{{ workOrder.ownerWorkerUser.firstName }} {{ workOrder.ownerWorkerUser.lastName }}</b>
        <ng-container *ngIf="ownerWorkerCompanyName">
          from <b>{{ ownerWorkerCompanyName }}</b>
        </ng-container>
        has been acknowledged.
        Waiting for the worker to accept the transfer and begin work.
      </div>
      <ng-container *ngTemplateOutlet="tocWorkerContextSection"></ng-container>
    </div>
  </div>
  <div class="action-bar" *ngSwitchCase="WorkOrderStateType.PendingReturn">
    <div class="action-bar-header">
      <div class="message-group">
        <step-progress-bar class="approval-progress-tracker" [transferOfControl]="true" [activeStep]=3 [workOrderState]="workOrderState"></step-progress-bar>
      </div>
    </div>
    <div class="action-bar-footer">
      <div class="heading">
        Transfer of control to OC has been requested by <b>{{ workOrder.ownerWorkerUser.firstName }} {{ workOrder.ownerWorkerUser.lastName }}</b>
        <ng-container *ngIf="ownerWorkerCompanyName">
          from <b>{{ ownerWorkerCompanyName }}</b>
        </ng-container>.
        Please acknowledge or reject transfer of control request.
      </div>
      <div *ngIf="showTocButtons()" class="button-group">
        <button class="btn btn-success" (click)="acknowledgeWorkOrderTransfer(workOrder, false)"><span><i class="fas fa-check-circle"></i></span> Acknowledge</button>
        <button class="btn btn-danger" (click)="rejectWorkOrderTransfer(workOrder, false)"><span><i class="fas fa-times-circle"></i></span> Reject</button>
      </div>
      <ng-container *ngTemplateOutlet="tocWorkerContextSection"></ng-container>
    </div>
  </div>
  <div class="action-bar" *ngSwitchCase="WorkOrderStateType.ReturnAcknowledged">
    <div class="action-bar-header">
      <div class="message-group">
        <step-progress-bar class="approval-progress-tracker" [transferOfControl]="true" [activeStep]=3 [workOrderState]="workOrderState"></step-progress-bar>
      </div>
    </div>
    <div class="action-bar-footer">
      <div class="heading">
        Return of control to Operation Controller by <b>{{ workOrder.ownerWorkerUser.firstName }} {{ workOrder.ownerWorkerUser.lastName }}</b>
        <ng-container *ngIf="ownerWorkerCompanyName">
          from <b>{{ ownerWorkerCompanyName }}</b>
        </ng-container>
        has been acknowledged.
        Waiting for the worker to close or suspend the work order.
      </div>
      <ng-container *ngTemplateOutlet="tocWorkerContextSection"></ng-container>
    </div>
  </div>

  <div class="action-bar" *ngSwitchCase="WorkOrderStateType.Open">
    <div class="action-bar-header">
      <div class="message-group">
        <ng-container *ngIf="!requiresToc">
          <ng-container *ngTemplateOutlet="openSessionsSummary"></ng-container>
        </ng-container>
        <step-progress-bar *ngIf="requiresToc" class="approval-progress-tracker" [transferOfControl]="true" [activeStep]=2 [workOrderState]="workOrderState"></step-progress-bar>
      </div>
    </div>
    <div class="action-bar-footer">
      <ng-container *ngIf="requiresToc">
        <ng-container *ngTemplateOutlet="openSessionsSummary"></ng-container>
      </ng-container>
      <ng-container *ngTemplateOutlet="tocWorkerContextSection"></ng-container>
      <div class="button-group">
        <button *ngIf="!requiresToc" class="btn btn-secondary" (click)="goToCheckInPage()"><span><i class="fas fa-user-plus"></i></span> Add to work party</button>
        <button *ngIf="isAcknowledgeSurrender" class="btn btn-success" (click)="acknowledgeWorkOrderSurrender(workOrder)"><span><i class="fas fa-check-circle"></i></span> Acknowledge Resume</button>
        <button class="btn btn-default" (click)="goToLiveSessions()"><span><i class="fas fa-video"></i></span> Go to live sessions</button>
        <button *ngIf="!requiresToc" class="btn btn-danger" [disabled]="!openSessions" [workOrderState] = "workOrderState" [openSessions]="openSessions" (click)="openCheckOutModal()"><span><i class="fas fa-sign-out-alt"></i></span> Check Out</button>
      </div>
    </div>
  </div>


  <div class="action-bar" *ngSwitchCase="WorkOrderStateType.Suspended">
    <div class="action-bar-header">
      <div class="message-group" *ngIf="!suspendedDetails">
        <div class="heading">
          This work order has been started and then suspended
        </div>
      </div>
      <div class="message-group" *ngIf="suspendedDetails">
        <div class="heading">
          This work order has been suspended by
          <b>{{ suspendedDetails.workerName }}</b>
          <ng-container *ngIf="suspendedDetails.companyName">
            from
            <b>{{ suspendedDetails.companyName }}</b>
          </ng-container>
          on
          <b>{{ suspendedDetails.suspendedTime | date: 'MMM d, y, h:mm a'}}</b>
        </div>
        <div *ngIf="suspendedDetails.reasonForSuspended" class="heading">
          With notes: <b>{{ suspendedDetails.reasonForSuspended }}</b>
        </div>
      </div>
    </div>
    <div class="action-bar-footer">
      <div class="button-group" *ngIf="!requiresToc || !isControlAdmin">
        <button *ngIf="!requiresToc" class="btn btn-success" (click)="goToCheckInPage()"><span><i class="fas fa-sign-in-alt"></i></span> Check In</button>
        <button *ngIf="!isControlAdmin" class="btn btn-danger" (click)="onCloseWorkOrder()"><span><i class="fas fa-times-circle"></i></span> Close</button>
      </div>
    </div>
  </div>


  <div class="action-bar" *ngSwitchCase="WorkOrderStateType.Surrendered">
    <div class="action-bar-header">
      <div class="message-group" *ngIf="surrenderedDetails">
        <div class="heading">
          This work order has been surrendered by
          <b>{{ surrenderedDetails.workerName }}</b>
          from
          <b>{{ surrenderedDetails.companyName }}</b>
          on
          <b>{{ surrenderedDetails.surrenderTime | date: 'MMM d, y, h:mm a'}}</b>
        </div>
        <div class="heading">With notes: <b>{{ surrenderedDetails.reasonForSurrender }}</b></div>
        <div class="heading">This work order can be resumed by {{ surrenderedDetails.workerName }} or another Authorised Technician provided an approved transfer has taken place and has been signed by both parties.</div>
      </div>
    </div>
    <div class="action-bar-footer">
      <div class="button-group">
        <button *ngIf="isAcknowledgeSurrender" class="btn btn-success" (click)="acknowledgeWorkOrderSurrender(workOrder)"><span><i class="fas fa-check-circle"></i></span> Acknowledge Surrender</button>
        <button class="btn btn-danger" (click)="overrideSurrender()"><span><i class="fas fa-unlock-alt"></i></span> Override and unlock</button>
        <button *ngIf="!requiresToc" class="btn btn-danger" (click)="onCloseWorkOrder()"><span><i class="fas fa-times-circle"></i></span> Close</button>
      </div>
    </div>
  </div>

</ng-container>
